import React, { useEffect } from 'react';
import { useAuth0, Auth0ContextInterface } from '@auth0/auth0-react';

interface AuthenticationStatusNotifierProps {
  /**
   * Callback fired on authentication. The response contains a function
   * that can be used to obtain the user's access token for use with API requests.
   */
  onAuthenticated: (
    accessTokenGenerator: Auth0ContextInterface['getAccessTokenSilently'],
    user: Auth0ContextInterface['user']
  ) => void;
}

const AuthenticationStatusNotifier: React.FC<AuthenticationStatusNotifierProps> = ({
  onAuthenticated,
}) => {
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();

  useEffect(() => {
    if (isAuthenticated) {
      onAuthenticated(getAccessTokenSilently, user);
    }
  }, [getAccessTokenSilently, isAuthenticated, onAuthenticated, user]);

  return null;
};

export { AuthenticationStatusNotifier };
